import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Welcome to Cloudflare Pages</h1>
      <h2>Please don't break me</h2>
    </div>
  );
}

export default App;
